
import AccountHead from "../components/account/header";
import TeamManager from "../components/AddTeammate";
import logodark from "../karuncup-dark-1.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import axios from "axios";

const AddTeam = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [leagueData, setLeagueData] = useState(null);
  const [error, setError] = useState(null); // State for errors

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      navigate("/");
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        localStorage.removeItem("access_token");
        navigate("/");
        return;
      }

      const userId = decodedToken.user_id;

      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const user = response.data;
          setUserData(user);

          return axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/leagues/${user.league}/`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
        })
        .then((leagueResponse) => {
          setLeagueData(leagueResponse.data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setError("Failed to fetch user or league data.");
          navigate("/"); // Redirect if data fetching fails
        });
    } catch (error) {
      console.error("Error decoding token:", error);
      setError("Invalid or expired token.");
      navigate("/");
    }
  }, [navigate]);

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  if (!userData) {
    return <div>درحال دریافت اطلاعات...</div>;
  }

  return (
    <div className="bg-slate-900 flex flex-col items-center justify-center text-slate-600">
      <AccountHead userData={userData} />
      <div className="w-full max-w-lg p-6 border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
        <div className="flex flex-col items-center pb-10">
          <img
            src={`${userData.teampic}`}
            alt="User Icon"
            width="96"
            height="96"
            className="mb-3 rounded-full shadow-lg"
          />
          <h5 className="mb-1 text-xl font-medium text-lime-500 dark:text-white">
            {userData.teamname
              ? `نام تیم: ${userData.teamname}`
              : "بدون نام تیم"}
          </h5>
          
          <TeamManager userData={userData} leagueData={leagueData} />
          
        </div>
      </div>
      <aside
        dir="rtl"
        className="group/sidebar flex flex-col shrink-0 lg:w-[300px] w-[250px] transition-all duration-300 ease-in-out m-0 fixed z-40 inset-y-0 right-0 bg-slate-800 border-r border-r-dashed border-r-slate-500 sidenav fixed-start loopple-fixed-start"
        id="sidenav-main"
      >
        <div className="flex shrink-0 px-8 items-center justify-between h-[96px]">
          <a
            className="mx-auto transition-colors duration-200 ease-in-out"
            href="https://www.loopple.com"
          >
            <img
              alt="Logo"
              src={logodark}
              width="96"
              height="96"
              className="mb-3 mx-auto"
            />
          </a>
        </div>
        <div className="flex items-center justify-between px-8 py-5">
      <div className="flex items-center mr-5">
      <div className="mr-5">
          <div className="inline-block relative shrink-0 cursor-pointer rounded-[.95rem]">
          <img className="w-[52px] h-[52px] shrink-0 inline-block rounded-[.95rem]" src={`${userData.teampic}`} alt="avatar image" />
          </div>
      </div>
      <div className="mr-2 ">
          <a href="javascript:void(0)" className=" text-lime-500 hover:text-lime-500 transition-colors duration-200 ease-in-out text-[1.075rem] font-medium dark:text-neutral-400/90 text-secondary-inverse">{userData.firstname} {userData.latname}</a>
          <span className="mr-2 text-slate-300 dark:text-stone-500 font-medium block text-[0.85rem]">{userData.teamrole}</span>
      </div>
      </div>
      <a className="inline-flex relative items-center group justify-end text-base font-medium leading-normal text-center align-middle cursor-pointer rounded-[.95rem] transition-colors duration-150 ease-in-out text-slate-300 bg-transparent shadow-none border-0" href="javascript:void(0)">
      <span className="leading-none transition-colors duration-200 ease-in-out peer shrink-0 group-hover:text-lime-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"></path>
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
      </span>
      </a>
  </div>
        <div className="border-b border-dashed  border-slate-900"></div>

        <div className="relative pl-3 my-5 overflow-y-scroll">
          <div className="flex flex-col w-full font-medium">
            <div>
              <span className="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]">
                <a
                  onClick={()=>{navigate('/profile')}}
                  className="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-slate-500 hover:text-cyan-500 transition-colors"
                >
                  پروفایل
                </a>
              </span>
            </div>
            <div>
              <span className="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]">
                <a
                  href="/invoice"
                  className="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-slate-500 hover:text-cyan-500 transition-colors"
                >
                  دریافت فاکتور
                </a>
              </span>
            </div>
            <div>
              <span className="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]">
                <a
                  href="/certificate"
                  className="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-slate-500 hover:text-cyan-500 transition-colors"
                >
                  دریافت گواهی
                </a>
              </span>
            </div>

            {/* Add other menu links */}
            <div className="block pt-5 pb-[.15rem]">
              <div className="px-4 py-[.65rem]">
                <span className="font-semibold text-[0.95rem] uppercase dark:text-neutral-500/80 text-slate-600">
                  لیگ {leagueData?.name}
                </span>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default AddTeam;
